import { CSSTransitionGroup } from 'react-transition-group'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class FadeInOut extends Component {
  static propTypes = { appear: PropTypes.bool }

  static defaultProps = { appear: false }

  render() {
    return (
      <CSSTransitionGroup
        transitionName="animation__fade"
        transitionAppear={this.props.appear}
        transitionAppearTimeout={250}
        transitionEnterTimeout={250}
        transitionLeaveTimeout={250}
      >
        {this.props.children}
      </CSSTransitionGroup>
    )
  }
}
